import { render, staticRenderFns } from "./panelItem.vue?vue&type=template&id=f7b18018"
import script from "./panelItem.vue?vue&type=script&lang=js"
export * from "./panelItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports